import React from 'react'
import { Link } from 'react-router-dom'
import { useCart, usePath } from 'lib/core/hooks'
import { TotalsTable } from 'lib/shared'
import { Container } from './styled'

export const Totals = () => {
  const { cart } = useCart()
  const path = usePath()

  if (!cart?.data?.prices) {
    return null
  }

  return (
    <Container>
      <p>
        <span>Order Summary</span> <Link to={path.cart}>Edit Cart</Link>
      </p>
      <TotalsTable />
    </Container>
  )
}
